import { createFileRoute } from "@tanstack/react-router";
import { PublicProfile } from "@/components/site/PublicProfile";
import { SITE_URL } from "@/components/site/seo";

/**
 * Legacy short share link. The canonical public URL is /profile/$slug, so this
 * route points its canonical there and stays out of the index.
 */
export const Route = createFileRoute("/p/$slug")({
  head: ({ params }) => ({
    meta: [
      { title: "Sales profile | CLOSDD" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/profile/${params.slug}` }],
  }),
  component: LegacyProfilePage,
});

function LegacyProfilePage() {
  const { slug } = Route.useParams();
  return <PublicProfile slug={slug} />;
}
